<template>
  <q-form
    @submit="onSubmit"
    class="q-gutter-md"
  >
    <q-input
      dense
      outlined
      readonly
      type="text"
      v-model="destination"
      class="q-mb-lg"
    />

    <q-input
      dense
      outlined
      no-error-icon
      v-model="credentials.code"
      placeholder="Código"
      mask="######"
      ref="code"
      type="text"
      :rules="[
        () => $v.credentials.code.required || 'Código é obrigatório',
        () => $v.credentials.code.minLength || 'Código inválido'
      ]"
    >
      <template #append>
        <q-icon
          size="xs"
          name="mdi-close"
          class="cursor-pointer"
          v-show="credentials.code"
          @click="credentials.code = ''"
        />
      </template>

      <template #prepend>
        <q-icon
          name="mdi-shield-key-outline"
          size="xs"
        />
      </template>
    </q-input>

    <q-input
      dense
      outlined
      no-error-icon

      autocorrect="off"
      autocapitalize="off"
      autocomplete="off"
      :spellcheck="false"
      hide-bottom-space

      v-model="credentials.password"
      ref="password"
      placeholder="Nova Senha"
      :type="isPassword ? 'password' : 'text'"
      :rules="[
        () => $v.credentials.password.required || 'Senha é obrigatória',
        () => $v.credentials.password.minLength || 'Senha inválida'
      ]"
    >
      <template #prepend>
        <q-icon
          name="mdi-lock-reset"
          size="xs"
        />
      </template>

      <template #append>
        <q-icon
          size="xs"
          :name="isPassword ? 'mdi-eye-off' : 'mdi-eye'"
          class="cursor-pointer"
          @click="isPassword = !isPassword"
        />
      </template>
    </q-input>

    <q-input
      dense
      outlined
      no-error-icon

      autocorrect="off"
      autocapitalize="off"
      autocomplete="off"
      :spellcheck="false"
      hide-bottom-space

      v-model="credentials.passwordConfirm"
      placeholder="Confirmar Senha"
      :type="isPassword ? 'password' : 'text'"
      :rules="[
        () => $v.credentials.passwordConfirm.sameAsPassword || 'Senha não confere'
      ]"
    >
      <template #prepend>
        <q-icon
          name="mdi-shield-check-outline"
          size="xs"
        />
      </template>

      <template #append>
        <q-icon
          size="xs"
          :name="isPassword ? 'mdi-eye-off' : 'mdi-eye'"
          class="cursor-pointer"
          @click="isPassword = !isPassword"
        />
      </template>
    </q-input>

    <div class="row items-center justify-between">
      <q-btn
        flat
        dense
        no-caps
        padding="0"
        :ripple="false"
        color="primary"
        label="Voltar"
        :to="authLoginRoute"
      />

      <AuthSubmit
        label="Alterar senha"
        :loading="auth.loading"
      />
    </div>
  </q-form>
</template>

<script>
import { mapState } from 'vuex'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { ROUTE_AUTH_SIGN_IN, ACTION_AUTH_CHANGE_PASSWORD } from '@/modules/auth/constants'
import AuthSubmit from '../components/AuthSubmit'

export default {
  components: {
    AuthSubmit
  },

  data () {
    const { email, code } = this.$route.query
    return {
      isPassword: true,
      credentials: { email, code },
      authLoginRoute: { name: ROUTE_AUTH_SIGN_IN }
    }
  },

  mounted () {
    this.$nextTick().then(() => (
      this.credentials.code
        ? this.$refs.password.focus()
        : this.$refs.code.focus()
    ))
  },

  computed: {
    ...mapState({
      auth: ({ authStore }) => authStore
    }),

    destination () {
      const details = this.auth?.cognitoUser?.CodeDeliveryDetails ?? {}
      const delivery = details.DeliveryMedium ? `${details.DeliveryMedium}:` : ''
      const destination = details.Destination ?? this.$route.query.email
      return destination ? `${delivery} ${destination}` : ''
    }
  },

  validations: {
    credentials: {
      code: { required, minLength: minLength(6) },
      password: { required, minLength: minLength(8) },
      passwordConfirm: { sameAsPassword: sameAs('password') }
    }
  },

  methods: {
    onSubmit () {
      if (this.auth.loading) return
      this.$store.dispatch(ACTION_AUTH_CHANGE_PASSWORD, this.credentials)
    }
  }
}
</script>
